<template>
  <div>
    <v-data-table
      :page="table.page"
      :headers="headers"
      :items="table.items"
      :items-per-page="table.itemsPerPage"
      :loading="loading.table"
      :server-items-length="table.totalCount"
      :footer-props="{
        'items-per-page-options': table.itemsPerPageOptions,
        itemsPerPageText: this.$t('defaults.table.items-per-page-text'),
        pageText: this.$t('defaults.table.page-text'),
      }"
      :no-data-text="$t('defaults.table.no-data-text')"
      :loading-text="$t('defaults.table.loading-text')"
      :options.sync="table.options"
      class="d-table"
      @update:options="optionsUpdated"
    >
      <template v-slot:[`item.apiName`]="{ item }">
        <div class="d-flex align-center">
          <v-chip
            label
            small
            :color="getMethodTypeColor(item.httpMethod)"
            class="mr-3"
            >{{ item.httpMethod }}</v-chip
          >
          <span class="body-2 text--primary">
            {{ `${item.projectName} / ` }}
            <span class="text--secondary">
              {{ item.apiName }}
            </span>
          </span>
        </div>
      </template>

      <template v-slot:[`item.logDateTime`]="{ item }">
        {{ formatDate(item.logDateTime, "dd.MM.yyyy HH:mm") }}
      </template>

      <template v-slot:[`item.requestedBy`]="{ item }">
        <div>
          <p class="mb-0 caption">
            <strong>{{ item?.requestedBy }}</strong> /
            {{ item.requestedFromIp }}
          </p>
          <p class="mb-0 caption">
            {{ item.requestedUrl }}
          </p>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import tableMixins from "@/mixins/tableMixins";
import { getRequestLogs } from "@/services/request";

export default {
  mixins: [tableMixins],
  data() {
    return {
      data: {
        id: "f4b48833-1b72-4177-afbf-1f091df977b1",

        requestedBy: "fex-user",
        requestedFromIp: "::ffff:10.244.154.147/128",
        requestedUrl:
          "digital-login/45c032b2-5d7f-4ffb-8de2-65d50b069e9b/certificates",
      },

      headers: [
        {
          text: this.$t("request-logs.list.table.headers.api-name"),
          value: "apiName",
          sortable: false,
          width: "40%",
        },
        {
          text: this.$t("request-logs.list.table.headers.requested-by"),
          value: "requestedBy",
          sortable: false,
          width: "30%",
        },
        {
          text: this.$t("request-logs.list.table.headers.http-status-code"),
          value: "httpStatusCode",
          sortable: false,
        },
        {
          text: this.$t("request-logs.list.table.headers.response-time"),
          value: "responseTime",
          sortable: false,
        },
        {
          text: this.$t("request-logs.list.table.headers.date"),
          value: "logDateTime",
          sortable: false,
        },
      ],
    };
  },
  props: {
    searchParams: Object,
  },
  methods: {
    getMethodTypeColor(method) {
      switch (method) {
        case "GET":
          return "info";
        case "POST":
          return "success";
        case "PUT":
          return "warning";
        case "PATCH":
          return "warning";
        case "DELETE":
          return "error";
        default:
          return "primary";
      }
    },
    handleFetchItems() {
      this.table.options.page = 1;
      this.table.page = 1;
      this.fetchItems();
    },
    fetchItems() {
      this.loading.table = true;
      getRequestLogs({
        pageSize: this.table.itemsPerPage,
        pageNumber: this.table.page,
        ...this.searchParams,
      })
        .then((response) => {
          this.table.items = response.items;
          this.table.totalCount = response.totalCount;

          if (
            response.totalCount <=
            (this.table.options.page - 1) * this.table.itemsPerPage
          ) {
            this.table.options.page = 1;
          }
        })
        .catch(() => {
          this.table.items = [];
          this.table.totalCount = 0;
        })
        .finally(() => {
          this.loading.table = false;
        });
    },
  },
  mounted() {
    this.$eventBus.$on("fetchRequests", this.handleFetchItems);
  },
  beforeDestroy() {
    this.$eventBus.$off("fetchRequests", this.handleFetchItems);
  },
};
</script>
